module.exports = __webpack_public_path__ + "static/media/8.f43e0bac.png";